import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { FIND_MY_ACCOUNT_URL, PATH } from 'shared';
import hamburgerIcon from 'images/utility-icons/hamburger.svg';
import { clearAccountLookupData } from '../slice';
import Sidebar from './Sidebar';
const logo = '/Alphaeon_Patient_Financing_Logo_SVG.svg';
function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const dispatch = useDispatch();
    const { verificationToken } = useSelector((state) => state.root.creditPortal.findMyAccount);
    const isInFindMyAccount = location.pathname.includes(PATH.FIND_MY_ACCOUNT);
    const isAuthenticated = !!verificationToken;
    const showHamburger = isInFindMyAccount && isAuthenticated;
    const handleLogoClick = () => {
        sessionStorage.removeItem('findMyAccount_session');
        dispatch(clearAccountLookupData());
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "header", children: [showHamburger && (_jsx("button", { onClick: () => setIsMenuOpen(true), className: "header__hamburger-button", "aria-label": "Open menu", children: _jsx("img", { src: hamburgerIcon, alt: "Menu" }) })), _jsx(Link, { to: FIND_MY_ACCOUNT_URL, onClick: handleLogoClick, children: _jsx("img", { src: logo, className: "logo", alt: "Logo", width: 224, height: 58.75 }) }), _jsxs("div", { className: "wizard-header-title", children: [_jsx(LockOutlinedIcon, {}), "Secure Application"] })] }), showHamburger && isMenuOpen && (_jsx(Sidebar, { isOpen: isMenuOpen, onClose: () => setIsMenuOpen(false) }))] }));
}
export default memo(Header);
